import React from 'react';
import classNames from 'classnames';
import { ControlLink } from '@moda/om';

import './AlphabeticalNav.scss';

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> {
  alphabet: string[];
  total?: number;
  onClick(letter: string): void;
}

export const NUMERIC = '#';
export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const NAV_OPTIONS = `${ALPHABET}${NUMERIC}`.split('');

export const AlphabeticalNav: React.FC<Props> = ({ alphabet, total = 0, onClick, ...rest }) => (
  <div className="AlphabeticalNav" {...rest}>
    <div className="AlphabeticalNav__meta">
      <span>Jump to:</span>

      <span>
        {total} Designer{total === 1 ? '' : 's'}
      </span>
    </div>

    <nav className="AlphabeticalNav__nav">
      {NAV_OPTIONS.map(symbol => (
        <ControlLink
          className={classNames('AlphabeticalNav__button', {
            'AlphabeticalNav__button--disabled': !alphabet.includes(symbol)
          })}
          key={symbol}
          onClick={() => onClick(symbol)}
          underlined={false}
        >
          {symbol}
        </ControlLink>
      ))}
    </nav>
  </div>
);
